import { FILTER_KEYS } from "/app/frontend/src/routes/_app/fleet-management/vehicles/index.tsx?tsr-shared=1";
const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/fleet-management/vehicles/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { createSearchValidator } from '@/lib/search-validators';
import { VEHICLE_SORT_KEYS } from '@/features/fleet-management/vehicle/model/vehicle-columns';
type VehicleFilters = {
  brand?: string;
  model?: string;
  modelType?: string;
  status?: string;
  location?: string;
  drivetrain?: string;
};

// The PRD's exactly-six list filters (manage-vehicles-13) — no other column
// header offers one.

export const Route = createFileRoute('/_app/fleet-management/vehicles/')({
  validateSearch: createSearchValidator<VehicleFilters, string>({
    tabs: [],
    filterKeys: FILTER_KEYS,
    // Drop a stored sortBy that names a column the backend no longer sorts on,
    // so a stale saved view cannot 400 the list on every entry.
    sortKeys: VEHICLE_SORT_KEYS
  }),
  staticData: {
    breadCrumb: 'Vehicles'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});

/**
 * Splits a multiselect filter from its URL form into the array the API takes.
 *
 * The framework keeps multiselect state comma-joined in the URL (see
 * `serialiseFilter`), so the split belongs here — at the boundary between URL
 * state and the typed API client — rather than in either of them.
 */